<template>
  <div class="write-off-table">
    <vxe-toolbar v-if="!disabled">
      <template v-slot:buttons>
        <el-button type="text" icon="el-icon-plus" @click="selectModal">选择</el-button>
        <el-button class="text-red" type="text" icon="el-icon-delete" @click="deleteTable">清空</el-button>
      </template>
    </vxe-toolbar>
    <div class="list">
      <vxe-table
        border
        ref="xTable"
        :data="value"
        @checkbox-change="checkboxChange"
        @checkbox-all="checkboxAll"
        :checkbox-config="{
          checkRowKeys: selection
        }"
        rowId="auditDetailAttachCode"
        show-overflow
      >
        <vxe-table-column type="checkbox" fixed="left" min-width="36" v-if="!disabled"></vxe-table-column>
        <vxe-table-column title="上账编码" field="accountCode" min-width="100"></vxe-table-column>
        <vxe-table-column title="核销编码" field="auditCode" min-width="100"></vxe-table-column>
        <vxe-table-column title="核销明细编码" field="auditDetailCode" min-width="100"></vxe-table-column>
        <vxe-table-column title="活动明细编码" field="actDetailCode" min-width="100"></vxe-table-column>
        <vxe-table-column title="附加信息行编号" field="attachCode" min-width="110"></vxe-table-column>
        <vxe-table-column title="所属销售公司" field="ownedSalesCompanyName" min-width="100"></vxe-table-column>
        <vxe-table-column title="归属客户名称" field="customerName" min-width="100"></vxe-table-column>
        <vxe-table-column title="活动申请编码" field="actCode" min-width="100"></vxe-table-column>
        <vxe-table-column title="活动申请名称" field="actName" min-width="100"></vxe-table-column>
        <vxe-table-column title="活动类型" field="fineName" min-width="100"></vxe-table-column>
        <vxe-table-column title="投入类型" field min-width="100"></vxe-table-column>
        <vxe-table-column title="活动开始时间" field="beginDate" min-width="100"></vxe-table-column>
        <vxe-table-column title="活动结束时间" field="endDate" min-width="100"></vxe-table-column>
        <vxe-table-column title="申请金额" field="applyAmount" min-width="100"></vxe-table-column>
        <vxe-table-column title="核销金额" field="auditAmount" min-width="100"></vxe-table-column>
        <vxe-table-column title="可上账金额" field="currentAllowAmount" min-width="100"></vxe-table-column>
        <vxe-table-column title="本次上账金额" field="accountAmount" min-width="150">
          <template #default="{ row }">
            <el-input-number
              v-model="row.accountAmount"
              :controls="false"
              :min="0"
              :max="row.currentAllowAmount"
              :precision="2"
              v-if="!disabled"
            ></el-input-number>
            <span v-else>{{ row.accountAmount }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="产品层级" field="productLevelCode" min-width="150">
          <template #default="{ row, rowIndex }">
            <el-select
              v-model="row.productLevelCode"
              filterable
              remote
              placeholder="产品层级"
              @focus="() => remoteMethod('lev', rowIndex)"
              :remote-method="v => remoteMethod('lev', rowIndex, v)"
              @change="(v) => levelChange(v, rowIndex)"
              :loading="loading"
              clearable
              :disabled="row.payType !== '4'"
              v-if="!disabled"
            >
              <el-option
                v-for="item in row.levelOptions"
                :key="item.value"
                :label="item.productLevelName"
                :value="item.productLevelCode"
              ></el-option>
            </el-select>
            <span v-else>{{ row.productLevelName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="货补产品" field="accountProductRespVos" min-width="200">
          <template #default="{ row, rowIndex }">
            <el-select
              v-model="row.productCode"
              reserve-keyword
              placeholder="货补产品"
              @focus="() => remoteMethod('pro', rowIndex)"
              :loading="loading"
              clearable
              :disabled="row.payType !== '4' || !row.productLevelCode"
              multiple
              collapse-tags
              v-if="!disabled"
            >
              <el-option
                v-for="item in row.productOptions"
                :key="item.value"
                :label="item.productName"
                :value="item.productCode"
              ></el-option>
            </el-select>
            <span v-else>{{ row.productNames }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="财务凭证编号" field min-width="100"></vxe-table-column>
        <vxe-table-column title="核销科目名称" field="auditSubjectName" min-width="100"></vxe-table-column>
        <vxe-table-column title="核销科目编码" field="auditSubjectCode" min-width="100"></vxe-table-column>
        <vxe-table-column title="核销备注" field="remarks" min-width="100"></vxe-table-column>
        <vxe-table-column title="申请人" field='createName' min-width="100"></vxe-table-column>
        <vxe-table-column title="核销年月" field='createDateAll' min-width="100"></vxe-table-column>
        <vxe-table-column v-if="!disabled" title="操作" width="60" fixed="right" align="center">
          <template v-slot="{ row }">
            <div class="setting-btn">
              <el-popconfirm
                title="此操作将永久删除该数据？"
                confirm-button-type="text"
                @confirm="removeRow(row)"
              >
                <el-button slot="reference" type="text">
                  <i class="el-icon-delete" style="color: #f5222d"></i>
                </el-button>
              </el-popconfirm>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" :beforeClose="beforeClose" />
  </div>
</template>

<script>
import SelectConfig from '../../../../../../components/select_org_cus_ter/select_config.vue';
import request from '../../../../../../utils/request';

export default {
  name: 'write_off',
  props: {
    value: Array,
    disabled: Boolean,
  },
  data() {
    return {
      selectRow: [],
      selection: [],
      loading: true,
    };
  },
  components: {
    SelectConfig,
  },
  methods: {
    // 核销选择列表
    selectModal() {
      const codes = this.value
        ? this.value.map((v) => v.auditDetailAttachCode)
        : [];
      const params = {
        functionCode: 'tpm_cost_account_write_off_list',
        data: [],
        selectionList: [],
        idKey: 'auditDetailAttachCode',
        paramData: {
          notInCodeList: codes,
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 确定选择关闭弹框前置函数
    beforeClose(val) {
      const payTypeType = val.map((v) => v.payTypeType);

      const state = payTypeType.every((v) => v === payTypeType[0]);
      if (!state) {
        this.$message.error('请选择相同支付方式类型');
      }

      return state;
    },
    // 选择数据回调
    async onGetSelect(val) {
      let num = val.length;

      const url = '/tpm/tpmAuditDetailController/generateAccountCode';
      const res = await request.get(url, { num });

      let list = JSON.parse(JSON.stringify(val));

      list = list.map((item) => {
        const v = item;
        if (!v.accountCode) {
          v.accountCode = res.result[num - 1];
          num -= 1;
        }

        v.productLevelCode = '';
        v.productCode = '';

        delete v.id;
        return v;
      });

      const newList = (this.value || []).concat(list);

      this.$emit('change', newList);
    },
    // 删除行数据
    removeRow(row) {
      const index = this.$refs.xTable.getRowIndex(row);
      const list = this.value.filter((v, k) => k !== index);

      this.selectRow = this.selectRow.filter((v) => v.auditDetailAttachCode !== row.auditDetailAttachCode);

      this.$emit('change', list, row);
    },
    // 清除
    deleteTable() {
      this.$confirm('请确认是否要清空当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('change', []);
          this.selectRow = [];
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 全选
    checkboxAll({ records }) {
      this.selectRow = records;
      this.selection = records.map((v) => v.auditDetailCode);
    },
    // 多选
    checkboxChange({ records }) {
      this.selectRow = records;
      this.selection = records.map((v) => v.auditDetailCode);
    },
    // 获取当前选择数据
    getCheckList() {
      return this.selectRow;
    },
    // 下拉框获取数据
    async remoteMethod(type, index, query) {
      this.loading = true;
      let url = '/mdm/mdmProductLevelController/productLevelSelectList';
      let params = {
        enableStatus: '009',
        pageNum: 0,
        pageSize: 100,
        productLevelCodeOrName: query || '',
      };

      if (type === 'pro') {
        const code = this.value[index].productLevelCode;
        url = '/mdm/mdmProductController/productSelectList';
        params = {
          enableStatus: '009',
          pageNum: 0,
          pageSize: 100,
          productCodeOrName: '1',
          productLevelCode: code || '',
        };
      }
      const res = await request.post(url, params);
      this.loading = false;

      if (res.success) {
        if (type === 'pro') {
          this.value[index].productOptions = res.result;
        } else {
          this.value[index].levelOptions = res.result;
        }
      }
    },
    // 层级修改
    levelChange(val, index) {
      const options = this.value[index].levelOptions.find((v) => v.productLevelCode === val);
      this.value[index].accountProductRespVos = [];
      this.value[index].productLevelName = options ? options.productLevelName : '';
    },
  },
};
</script>

<style lang="less" scoped>
.write-off-table {
  .text-red {
    color: #f56c6c!important;
  }
}
</style>
